import React from "react";

export default function ReloadIcon({ color = "#616161", ...restProps }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
      <path
        fill={color}
        fillRule="evenodd"
        d="M6 10.5c-2.49 0-4.5-2.01-4.5-4.5S3.51 1.5 6 1.5c1.24 0 2.36.52 3.17 1.33L7 5h5V0l-1.76 1.76A6.003 6.003 0 0 0 6 0C2.69 0 .01 2.69.01 6S2.69 12 6 12a5.98 5.98 0 0 0 5.9-5h-1.52C9.92 9 8.14 10.5 6 10.5z"
        {...restProps}
      />
    </svg>
  );
}
